import { features } from '@/mocks/homeData';

const featureIcons = [
  { bg: 'bg-primary-100', color: 'text-primary-600' },
  { bg: 'bg-accent-100', color: 'text-accent-600' },
  { bg: 'bg-secondary-100', color: 'text-secondary-600' },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 scroll-mt-16 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 text-xs font-medium text-primary-700 bg-primary-100 rounded-full mb-3">为什么选择我们</span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">平台特色</h2>
          <p className="text-sm text-foreground-500 mt-2 max-w-lg mx-auto">古古漫画网为漫画阅读体验打造的三大核心优势</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-4xl mx-auto">
          {features.map((feat, i) => (
            <div key={feat.id} className="text-center p-6 rounded-lg bg-background-100 border border-background-200/70">
              <div className={`w-14 h-14 md:w-16 md:h-16 mx-auto mb-4 flex items-center justify-center rounded-2xl ${featureIcons[i].bg} ${featureIcons[i].color}`}>
                <i className={`${feat.icon} text-2xl`}></i>
              </div>
              <h3 className="font-heading font-bold text-base text-foreground-900 mb-2">{feat.title}</h3>
              <p className="text-sm text-foreground-500 leading-relaxed">{feat.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}